// Insert closestOption if it was filtered out
export const withClosestOption = (filtered, closestOption) => {
    if (!closestOption) {
        return filtered;
    }
    const isClosestPresent = filtered.some((option) => { var _a, _b; return ((_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.getTime()) === ((_b = closestOption === null || closestOption === void 0 ? void 0 : closestOption.value) === null || _b === void 0 ? void 0 : _b.getTime()); });
    if (!isClosestPresent) {
        // Inject closestOption
        filtered.push(closestOption);
        filtered.sort((d1, d2) => d1.value.getTime() - d2.value.getTime());
    }
    return filtered;
};
//# sourceMappingURL=withClosestOption.js.map